import { Link, useLocation } from "react-router-dom";
import "../styles/BottomNav.css";

export default function BottomNav() {

  const location = useLocation();

  return (

    <div className="bottom-nav">

      <Link
        to="/"
        className={location.pathname === "/" ? "active" : ""}
      >
        🏠
        <span>Home</span>
      </Link>


      <Link
        to="/creations"
        className={location.pathname === "/creations" ? "active" : ""}
      >
        💼
        <span>Work</span>
      </Link>


      <Link
        to="/services"
        className={location.pathname === "/services" ? "active" : ""}
      >
        ⚙️
        <span>Services</span>
      </Link>
  <Link
        to="/Apps"
        className={location.pathname === "/Apps" ? "active" : ""}
      >
        📲
        <span>Apps</span>
      </Link>


      <Link
        to="/about"
        className={location.pathname === "/about" ? "active" : ""}
      >
        👤
        <span>About</span>
      </Link>


      <Link
        to="/contact"
        className={location.pathname === "/contact" ? "active" : ""}
      >
        ✉️
        <span>Contact</span>
      </Link>

    </div>

  );
}